import { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';

/**
 * GH#1883 — la región viva (`role="status"`) se monta SIEMPRE, vacía, y el aviso
 * se renderiza adentro. Antes el componente devolvía `null` hasta tener aviso,
 * así que la región aparecía ya llena y los lectores de pantalla pueden no
 * anunciarla (mismo patrón que GH#1802 en los toasts). Desde GH#1771 este
 * banner es la única forma de enterarse de que hay una versión nueva.
 */
export const PWAUpdateBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener('pwa:update-available', handler);
    return () => window.removeEventListener('pwa:update-available', handler);
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 left-1/2 z-50 -translate-x-1/2"
    >
      {visible && (
        <div className="rounded-lg border border-blue-200 bg-blue-50 p-3 shadow-lg dark:border-blue-800 dark:bg-blue-950">
          <div className="flex items-center gap-3">
            <RefreshCw size={18} className="text-blue-600 dark:text-blue-400" aria-hidden="true" />
            <p className="text-sm text-blue-900 dark:text-blue-100">
              Nueva versión disponible
            </p>
            <button
              type="button"
              onClick={handleReload}
              className="rounded-md bg-blue-600 px-3 py-1 text-xs font-medium text-white hover:bg-blue-700"
            >
              Actualizar
            </button>
            <button
              type="button"
              onClick={() => setVisible(false)}
              aria-label="Cerrar aviso de nueva versión"
              className="text-blue-400 hover:text-blue-600"
            >
              <X size={16} aria-hidden="true" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PWAUpdateBanner;
